/* Presentation only: keep content, destinations, forms and commerce behavior intact. */
(() => {
  const english = document.documentElement.lang.startsWith('en');
  const german = document.documentElement.lang.startsWith('de');
  function enhance(scope = document) {
    scope.querySelectorAll('.ttg-reading, .shopify-policy__body .rte').forEach(root => {
      if (root.dataset.ttgReadingReady) return;
      root.dataset.ttgReadingReady = 'true';
      root.querySelectorAll('[style]').forEach(el => {
        // Imported rich text carries conflicting font and alignment declarations.
        ['font-family','font-size','line-height','color','font-weight','text-align','letter-spacing','text-shadow'].forEach(property => el.style.removeProperty(property));
      });
      [...root.querySelectorAll('p,div,span')].reverse().forEach(el => {
        if (!el.textContent.trim() && !el.querySelector('img,svg,video,iframe,hr,br,input,button,script,style') && !el.id) el.remove();
        else if (!el.textContent.trim() && el.matches('p') && !el.querySelector('img,svg,video,iframe,input,button') && !el.id) el.hidden = true;
      });
      // Existing contact headings were bold paragraphs; give them a semantic hierarchy.
      if (root.closest('[data-ttg-page="contatti"], [data-ttg-page="contatti-social"]')) {
        root.querySelectorAll('p').forEach(el => {
          if (el.children.length === 1 && el.firstElementChild.tagName === 'STRONG' && el.textContent.trim() === el.firstElementChild.textContent.trim()) {
            const heading = document.createElement('h2'); heading.textContent = el.textContent; el.replaceWith(heading);
          }
        });
      }
      if (root.closest('[data-ttg-page="affiliazioni"]')) {
        const first = root.querySelector('a[href="https://www.upad.it"]');
        if (first && first.parentElement.children.length === 6) {
          const grid = first.parentElement; grid.classList.add('ttg-affiliates'); grid.removeAttribute('style');
          [...grid.children].forEach(card => {
            card.removeAttribute('style'); card.classList.add('ttg-affiliate');
            card.querySelectorAll('span').forEach(el => el.removeAttribute('style'));
          });
        }
      }
      root.querySelectorAll('table').forEach((table,index) => {
        if (table.closest('.ttg-table-scroll')) return;
        const region = document.createElement('div'); region.className = 'ttg-table-scroll';
        region.setAttribute('role','region'); region.setAttribute('aria-label',german ? 'Tabelle '+(index+1)+' – bei Bedarf seitlich scrollen' : english ? 'Table '+(index+1)+' — scroll horizontally if needed' : 'Tabella '+(index+1)+' — scorri orizzontalmente se necessario');
        region.tabIndex = 0; table.before(region); region.append(table);
        table.querySelectorAll('thead th').forEach(th => th.setAttribute('scope','col'));
        if (root.closest('[data-ttg-page="contatti"], [data-ttg-page="contatti-social"]') && table.tHead && table.tBodies.length) {
          // The same opening hours as the table, arranged by day on narrow screens.
          const hours = document.createElement('dl'); hours.className = 'ttg-hours-list';
          [...table.tBodies[0].rows].forEach(row => {
            const cells = [...row.cells]; if (cells.length !== 3) return;
            const entry = document.createElement('div'); const day = document.createElement('dt'); day.textContent = cells[0].textContent.trim();
            const times = document.createElement('dd');
            [...new Set(cells.slice(1).flatMap(cell => cell.innerText.split(/\n/).map(text => text.trim())).filter(text => text && !/^[—–-]$/.test(text)))].forEach(text => {
              const line = document.createElement('span'); line.textContent = text; times.append(line);
            });
            entry.append(day,times); hours.append(entry);
          });
          if (hours.children.length) { region.classList.add('ttg-hours-table'); region.after(hours); }
        }
        if (root.closest('[data-ttg-page="spedizioni"]')) {
          const hint = document.createElement('p'); hint.className = 'ttg-table-hint';
          hint.textContent = german ? 'Scrolle seitlich, um alle Gewichtsstufen zu sehen →' : english ? 'Swipe the table to see all weight bands →' : 'Scorri la tabella per vedere tutte le fasce di peso →';
          region.before(hint);
        }
      });
      const page = root.closest('.ttg-info-page');
      if (page && !page.querySelector('.ttg-reading-toc')) {
        const headings = [...root.querySelectorAll('h2,h3')].filter(h => h.textContent.trim());
        if (headings.length >= 3) {
          const nav = document.createElement('nav'); nav.className = 'ttg-reading-toc'; nav.setAttribute('aria-label',german ? 'Auf dieser Seite' : english ? 'On this page' : 'In questa pagina');
          headings.forEach((h,index) => { if (!h.id) h.id = 'ttg-info-'+index; const link = document.createElement('a'); link.href = '#'+h.id; link.textContent = h.textContent; nav.append(link); });
          root.before(nav);
        }
      }
      root.querySelectorAll('a:has(img)').forEach(link => {
        if (!link.textContent.trim() && !link.getAttribute('aria-label')) {
          const img = link.querySelector('img');
          const host = new URL(link.href,location.href).hostname.replace(/^www\./,'');
          link.setAttribute('aria-label',img.alt || host);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => enhance()); else enhance();
  document.addEventListener('shopify:section:load',event => enhance(event.target));
})();
